import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { getFixedCostPlanningProgressBarLabel } from 'modules/project_management/lib/formatText'

import { InsightCard } from '../InsightCard'

interface ICurrentProfitProps {
  expectedProfit: number
  currentProfit: number
  currency: string
  locale: string
}

const CurrentProfit = ({
  expectedProfit,
  currentProfit,
  currency,
  locale,
}: ICurrentProfitProps) => {
  const labelBalance = getFixedCostPlanningProgressBarLabel(
    Math.round(currentProfit * 100),
    Math.round(expectedProfit * 100),
    currency,
    locale
  )
  const percentageProfitCalculation = Math.round(
    ((currentProfit - expectedProfit) / expectedProfit) * 100
  )

  const positiveSymbol = percentageProfitCalculation > 0 ? '+' : ''

  const percentageProfitLabel = `${positiveSymbol}${percentageProfitCalculation}%`
  return (
    <InsightCard title={i18n.t('project_management.insights.profit_insight')} titleGap="s6">
      <Box flexDirection="column" gap="s6" paddingTop="s6">
        <Text.Header2 weight="semibold">{labelBalance}</Text.Header2>
        <Box flexDirection="row">
          <Text color="grey800" size="200" weight="semibold" ellipsis whiteSpace="nowrap">
            {percentageProfitLabel}
          </Text>
          <Text color="grey800" size="200" ellipsis whiteSpace="nowrap">
            {'\u00A0'}
            {i18n.t('project_management.insights.tags.profit_percentage')}
          </Text>
        </Box>
      </Box>
    </InsightCard>
  )
}
export default CurrentProfit
